export default __webpack_public_path__ + "static/ricta4-3fe5f47420792883155a5e43ee574f91.svg";